<template>
  <div class="course-component">
    <h2>Curso</h2>
    <b-form-group
      label="Nome Curso"
      label-for="basicInput"
    >
      <b-form-input
        id="basicInput"
        v-model="curso.nome"
        placeholder="Nome Curso"
      />
    </b-form-group>
    <div>
      <label for="textarea-default">Textarea</label>
      <b-form-textarea
        id="textarea-default"
        v-model="curso.descricao"
        placeholder="Textarea"
        rows="3"
      />
    </div>
    <div class="mt-3">
      <label for="input-file">Imagem capa</label>
      <input-file-custom
        id="input-file"
        :image-rendered="true"
        :rendered-image="curso.capa"
        @atualizarImagem="updatedImagem($event)"
      />
    </div>
    <div class="mt-2 d-flex justify-content-end">
      <button
        class="btn btn-primary"
        @click="salvarCurso()"
      >
        Salvar Curso
      </button>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BFormTextarea } from 'bootstrap-vue'
import InputFileCustom from '@/views/App/Cursos/InputFileCustom.vue'
import { useApi, useApiAWS } from '@/composables/useApi'

const apiBack = useApi()
const apiAws = useApiAWS()
export default {
  components: {
    InputFileCustom, BFormInput, BFormTextarea, BFormGroup,
  },
  data() {
    return {
      curso: [],
      capaInicial: [],
      cursoId: this.$route.params.id,
    }
  },
  computed: {
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.domainUser = newUserData.user_domain
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  mounted() {
    this.buscarDadosCurso()
  },
  methods: {
    async salvarCurso() {
      if (this.curso.capa !== this.capaInicial) {
        await this.uploadCapaCurso()
      }
      console.log('SALVAR CURSO')
      console.log('IMAGEM', this.curso.capa)
      await apiBack.put(`/editCursoById/?id=${this.cursoId}`, {
        nome: this.curso.nome,
        descricao: this.curso.descricao,
        capa: this.curso.capa,
        status: this.curso.status,
      })
        .then(() => {
          this.buscarDadosCurso()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async uploadCapaCurso() {
      const formData = new FormData()
      formData.append('video', this.curso.capa)
      formData.append('caminho', `${this.getUserData.user_file_key}`)
      await apiAws.post('/thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async response => {
        this.curso.capa = response.data.data.fileUrl
      }).catch(err => {
        console.log(err)
      })
    },
    async buscarDadosCurso() {
      await apiBack.get(`/getCursoById?id=${this.cursoId}`)
        .then(data => {
          this.curso = data.data[0]
          this.capaInicial = data.data[0].capa
        })
        .catch(err => console.error(err))
    },
    updatedImagem(event) {
      console.log(event)
      this.curso.capa = event
    },
  },
}
</script>

<style>
/* Add your CSS styles here for customizing the component's appearance */
.course-component {
  /* Your styles here */
}
.avatar {
  /* Your styles here */
}
.input-container {
  /* Your styles here */
}
.textarea-container {
  /* Your styles here */
}
</style>
